"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRedirection = void 0;
const axios_client_1 = require("@invivodf/axios-client");
const routes_1 = require("../../routes");
const getRedirection = (client) => async (sourceUrl) => {
    const response = await client
        .post(routes_1.ENDPOINTS.GET_REDIRECTION.path, { source_url: sourceUrl }, { timeout: 300 })
        .catch((error) => {
        if (error instanceof axios_client_1.HttpError) {
            if (error.status === 422) {
                return { data: null };
            }
        }
        throw error;
    });
    return response.data;
};
exports.getRedirection = getRedirection;
